import { useTheme } from '../../context/ThemeContext.jsx';
import { useAuth } from '../../context/AuthContext.jsx';

const NAV = [
  { id: 'library', label: 'library' },
  { id: 'team', label: 'team' },
  { id: 'playground', label: 'playground' },
];

function RiesterWordmark({ color }) {
  return (
    <svg viewBox="0 0 138 34" fill={color} aria-label="RIESTER" style={{ height: 17, width: 'auto', display: 'block' }}>
      <path fillRule="evenodd" clipRule="evenodd" d="M4.46121 33.596H0V7.62529H17.4096V11.7013H4.46121V33.596Z" />
      <path d="M22.125 0C20.587102 0 19.412109 1.1173772 19.412109 2.6972656 19.412109 4.277144 20.587102 5.3964844 22.125 5.3964844 23.662798 5.3964844 24.837891 4.277144 24.837891 2.6972656 24.837891 1.1173772 23.662798 0 22.125 0zM20.027344 7.625 20.027344 33.595703 24.228516 33.595703 24.228516 7.625 20.027344 7.625z" />
      <path fillRule="evenodd" clipRule="evenodd" d="M31.4316 21.4331V21.7793C31.5839 26.721 34.7104 30.1837 39.6794 30.1837C43.3644 30.1837 46.237 28.2504 47.1074 24.8886H51.3583C50.3355 30.0827 46.0339 33.9062 39.9913 33.9062C32.157 33.9062 27.0356 28.5606 27.0356 20.6179C27.0356 12.6752 32.0554 7.32951 39.4255 7.32951C46.7955 7.32951 51.6122 11.961 51.8153 19.6512C51.8153 20.1721 51.7718 20.7302 51.725 21.2968L51.7156 21.4102L51.7137 21.4331H31.4316ZM47.3033 17.9631H31.6855C32.0917 13.7356 35.6316 10.9871 39.469 10.9871C43.8214 10.9871 46.8971 13.4831 47.3033 17.9631Z" />
      <path d="M75.2892 26.0573C75.2892 30.8979 70.6321 33.899 64.8435 33.899C58.0827 33.899 53.4257 30.7392 53.3241 25.0401H57.6257C57.7781 28.0917 60.4911 30.3352 64.8435 30.3352C68.5285 30.3352 71.1399 28.7554 71.1399 26.3603C71.1399 23.0995 68.2746 22.847 64.3792 22.3853C58.5397 21.6711 53.8827 20.5024 53.8827 15.0991C53.8827 10.3666 58.2351 7.25737 64.1253 7.30787C70.0663 7.35837 74.368 10.1069 74.7742 15.5103H70.4726C70.1679 12.8627 67.7088 10.8788 64.1253 10.8788C60.5418 10.8788 58.032 12.4082 58.032 14.8033C58.032 17.6529 60.7957 18.0136 64.5896 18.4681C70.5306 19.1823 75.2892 20.3004 75.2892 26.0573Z" />
      <path d="M88.4625 29.7798H91.9154V33.596H88.049C83.0292 33.596 81.2375 31.4029 81.2375 26.822V11.4415H74.5058V7.62529H94.8387V11.4415H85.4376V26.7715C85.4376 28.9574 86.2065 29.7725 88.4625 29.7725V29.7798Z" />
      <path fillRule="evenodd" clipRule="evenodd" d="M97.53 21.5196V21.8731C97.6823 26.8148 100.809 30.2775 105.778 30.2775C109.463 30.2775 112.335 28.3442 113.206 24.9824H117.457C116.434 30.1765 112.132 34 106.09 34C98.2554 34 93.134 28.6544 93.134 20.7116C93.134 12.7689 98.1538 7.4233 105.524 7.4233C112.894 7.4233 117.711 12.0547 117.914 19.745C117.914 20.3006 117.864 20.8985 117.814 21.5038L117.812 21.5268H97.5372L97.53 21.5196ZM113.402 18.0569H97.7839C98.1901 13.8294 101.73 11.0808 105.567 11.0808C109.92 11.0808 112.995 13.5769 113.402 18.0569Z" />
      <path d="M120.59 33.596H125.052V11.7013H138V7.62529H120.59V33.596Z" />
    </svg>
  );
}

export default function HeaderBar({ activatedCount, totalSyncedSize, teamMembers, screen, onNavigate, onShowSmartSearch, onShowAdminPanel }) {
  const { theme } = useTheme();
  const { user, logout } = useAuth();
  const isAdmin = user?.role === 'admin';

  return (
    <header style={{
      display: 'flex', alignItems: 'center', justifyContent: 'space-between',
      gap: 24, padding: '0 24px', height: 72,
      borderBottom: `1px solid ${theme.border}`,
      background: theme.bg,
      position: 'sticky', top: 0, zIndex: 100,
    }}>
      <div style={{ display: 'flex', alignItems: 'baseline', gap: 16, flexShrink: 0 }}>
        <RiesterWordmark color={theme.text} />
        <span style={{ width: 1, height: 18, background: theme.borderMedium, display: 'block' }} />
        <span style={{ fontSize: 10, letterSpacing: '0.18em', textTransform: 'uppercase', color: theme.textFaint }}>font library</span>
      </div>

      <div style={{ display: 'flex', alignItems: 'center', gap: 28, flexShrink: 0 }}>
        {NAV.map((n) => (
          <span
            key={n.id}
            onClick={() => onNavigate(n.id)}
            style={{
              fontSize: 15, textTransform: 'lowercase', whiteSpace: 'nowrap', cursor: 'pointer',
              paddingBottom: 2,
              color: screen === n.id ? theme.text : theme.accent,
              borderBottom: `2px solid ${screen === n.id ? theme.text : 'transparent'}`,
            }}
          >{n.label}</span>
        ))}
      </div>

      <div style={{ display: 'flex', alignItems: 'center', gap: 20 }}>
        <div style={{ display: 'flex', alignItems: 'center', gap: 8, fontSize: 11, letterSpacing: '0.1em', textTransform: 'uppercase', color: theme.textFaint }}>
          <span style={{ width: 6, height: 6, background: theme.accent, display: 'inline-block' }} />
          <span>{activatedCount} active &middot; {totalSyncedSize} synced</span>
        </div>

        <span onClick={onShowSmartSearch} style={{ fontSize: 14, textTransform: 'lowercase', color: theme.accent, cursor: 'pointer' }}>
          smart search.
        </span>

        <a
          href="/download"
          title="Download Desktop Agent"
          style={{
            background: theme.bgInput, border: `1px solid ${theme.borderMedium}`,
            color: theme.textMuted, padding: '5px 8px', cursor: 'pointer', fontSize: 14,
            textDecoration: 'none', display: 'inline-flex', alignItems: 'center',
          }}
        >{'⬇'}</a>

        {isAdmin && (
          <button
            onClick={onShowAdminPanel}
            title="Admin Panel"
            style={{
              background: theme.bgInput, border: `1px solid ${theme.borderMedium}`,
              color: theme.textMuted, padding: '5px 8px', cursor: 'pointer', fontSize: 14,
            }}
          >{'\u{1F6E1}'}</button>
        )}

        <div
          onClick={() => onNavigate('team')}
          title="Manage team"
          style={{ display: 'flex', cursor: 'pointer' }}
        >
          {teamMembers.slice(0, 4).map((t, i) => (
            <div key={t.id || i} title={t.name} style={{
              width: 26, height: 26, borderRadius: '50%',
              background: t.color || theme.accent,
              display: 'flex', alignItems: 'center', justifyContent: 'center',
              fontSize: 9, fontWeight: 700, color: theme.accentFg,
              border: `2px solid ${theme.bg}`,
              marginLeft: i > 0 ? -6 : 0,
              position: 'relative', zIndex: teamMembers.length - i,
            }}>{t.initials || t.name?.slice(0, 2).toUpperCase()}</div>
          ))}
          {teamMembers.length > 4 && (
            <div style={{
              width: 26, height: 26, borderRadius: '50%',
              background: theme.bgInput,
              display: 'flex', alignItems: 'center', justifyContent: 'center',
              fontSize: 10, color: theme.textMuted,
              border: `2px solid ${theme.bg}`, marginLeft: -6,
            }}>+{teamMembers.length - 4}</div>
          )}
        </div>

        <button
          onClick={logout}
          title="Sign out"
          style={{
            background: theme.bgInput, border: 'none',
            color: theme.textTertiary, padding: '5px 10px', cursor: 'pointer', fontSize: 11,
            fontFamily: 'inherit',
          }}
        >{user?.initials || '??'} &#9211;</button>
      </div>
    </header>
  );
}
